'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoRetiradaCtrl', function ($scope, $stateParams, Historico) {
        // classe para animação da view
        $scope.pageClass = 'page-retirada';

        Historico.getSituacaoOs($stateParams.idPedido)
            .then(function (pedido) {
                $scope.pedido = pedido;
            })
            .catch($scope.tratarErrosBackEnd);
    });